export function normalizePhoneNumber(raw: string): string {
  const trimmed = raw.trim();
  if (!trimmed) return "";
  const body = trimmed.startsWith("+") ? trimmed.slice(1) : trimmed;
  const digits = body.replace(/\D/g, "");
  if (!digits) return "";
  return `+${digits}`;
}

/** National digits only (strips formatting; keeps leading 0 if present). */
export function nationalPhoneDigits(raw: string): string {
  return raw.replace(/\D/g, "");
}

/**
 * Build E.164 from a selected country dial code + national number.
 * If the user already typed a leading +, treat the whole value as E.164.
 */
export function buildE164Phone(
  nationalOrFull: string,
  dialCode: string
): string {
  const trimmed = nationalOrFull.trim();
  if (!trimmed) return "";
  if (trimmed.startsWith("+")) {
    return normalizePhoneNumber(trimmed);
  }
  const national = nationalPhoneDigits(trimmed);
  if (!national) return "";
  const codeDigits = dialCode.replace(/\D/g, "");
  if (!codeDigits) return normalizePhoneNumber(national);
  // Drop a single leading trunk 0 when dialing internationally.
  const withoutTrunk = national.startsWith("0") ? national.slice(1) : national;
  return `+${codeDigits}${withoutTrunk || national}`;
}

/** Digits only, excluding the leading + (E.164 body). */
export function phoneDigitCount(normalized: string): number {
  if (!normalized.startsWith("+")) return 0;
  return normalized.slice(1).replace(/\D/g, "").length;
}

export function isPhoneValidForOtp(normalized: string): boolean {
  return phoneDigitCount(normalized) >= 10;
}

export function allowOnlyOtpDigits(next: string, maxLen = 6): string {
  return next.replace(/\D/g, "").slice(0, maxLen);
}
